import { z } from 'zod';

// Attachment change schema
export const zodContractAttachmentChangeSchema = z.object({
  action: z.enum(['added', 'deleted']),
  fileId: z.string(),
  name: z.string(),
});

// Changed fields schema (key-value pairs with old/new values)
export const zodContractChangedFieldsSchema = z
  .record(
    z.string(),
    z.object({
      new: z.unknown().nullish(),
      old: z.unknown().nullish(),
    }),
  )
  .nullish();

// Item changes schema
export const zodContractItemChangeSchema = z.object({
  articleNr: z.string().nullish(),
  changedFields: zodContractChangedFieldsSchema,
  changeType: z.string().nullish(),
  itemId: z.string().nullish(),
});

export const zodContractHistoryDeliveryNoteItemSchema = z.object({
  articleId: z.string().nullish(),
  articleName: z.string().nullish(),
  posNr: z.string().nullish(),
  quantity: z.number().nullable(),
  quantityUnit: z.string().nullable(),
});

// A summed quantity is available only when the delivery-note lines use one
// compatible unit. Individual lines remain available when no sum is possible.
export const zodContractHistoryEventDataSchema = z.object({
  dlnNr: z.string(),
  itemCount: z.number().nullish(),
  items: z.array(zodContractHistoryDeliveryNoteItemSchema).nullish(),
  itemsTruncated: z.boolean().nullish(),
  quantity: z.number().nullable(),
  quantityUnit: z.string().nullable(),
});

// History entry schema
export const zodContractHistoryEntrySchema = z.object({
  action: z.string(),
  actorDisplay: z.string(),
  attachmentChanges: z.array(zodContractAttachmentChangeSchema).nullish(),
  changedFields: zodContractChangedFieldsSchema,
  createdAt: z.string(),
  // History entries written before structured event details were introduced
  // have no event data because the nullable column was not backfilled.
  eventData: zodContractHistoryEventDataSchema.nullish(),
  itemChanges: z.array(zodContractItemChangeSchema).nullish(),
  notes: z.string().nullish(),
  previousStatus: z.string().nullish(),
  snapshot: z.unknown(),
  status: z.string(),
  versionNumber: z.number(),
});

// Response schema for contract history (paginated)
export const zodContractHistoryResponseSchema = z.object({
  contractId: z.string(),
  entries: z.array(zodContractHistoryEntrySchema),
  limit: z.number(),
  offset: z.number(),
  totalCount: z.number(),
});
